/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Представляет связанное нативное приложение в манифесте.
 * @export
 * @interface FxIdWebFeaturesPlayManifestRelatedApplicationsOptions
 */
export interface FxIdWebFeaturesPlayManifestRelatedApplicationsOptions {
    /**
     * Платформа связанного приложения (например, "play" или "itunes").
     * @type {string}
     * @memberof FxIdWebFeaturesPlayManifestRelatedApplicationsOptions
     */
    Platform: string;
    /**
     * URL-адрес приложения в магазине.
     * @type {string}
     * @memberof FxIdWebFeaturesPlayManifestRelatedApplicationsOptions
     */
    Url: string;
    /**
     * Идентификатор приложения на платформе.
     * @type {string}
     * @memberof FxIdWebFeaturesPlayManifestRelatedApplicationsOptions
     */
    Id?: string | null;
}

/**
 * Check if a given object implements the FxIdWebFeaturesPlayManifestRelatedApplicationsOptions interface.
 */
export function instanceOfFxIdWebFeaturesPlayManifestRelatedApplicationsOptions(value: object): value is FxIdWebFeaturesPlayManifestRelatedApplicationsOptions {
    if (!('Platform' in value) || value['Platform'] === undefined) return false;
    if (!('Url' in value) || value['Url'] === undefined) return false;
    return true;
}

export function FxIdWebFeaturesPlayManifestRelatedApplicationsOptionsFromJSON(json: any): FxIdWebFeaturesPlayManifestRelatedApplicationsOptions {
    return FxIdWebFeaturesPlayManifestRelatedApplicationsOptionsFromJSONTyped(json, false);
}

export function FxIdWebFeaturesPlayManifestRelatedApplicationsOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesPlayManifestRelatedApplicationsOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'Platform': json['platform'],
        'Url': json['url'],
        'Id': json['id'] == null ? undefined : json['id'],
    };
}

export function FxIdWebFeaturesPlayManifestRelatedApplicationsOptionsToJSON(json: any): FxIdWebFeaturesPlayManifestRelatedApplicationsOptions {
    return FxIdWebFeaturesPlayManifestRelatedApplicationsOptionsToJSONTyped(json, false);
}

export function FxIdWebFeaturesPlayManifestRelatedApplicationsOptionsToJSONTyped(value?: FxIdWebFeaturesPlayManifestRelatedApplicationsOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'platform': value['Platform'],
        'url': value['Url'],
        'id': value['Id'],
    };
}

